function Header() {
    return (
        <>
            <div class="hero-backgrounds">
                <div class="hero-background-tentang-kami">
                    <div class="hero-background-title-blue"></div>
                </div>
            </div>

            <article class="hero">
                <div class="hero-message-wrapper tentang-kami">
                    <div class="hero-logo">
                        <h1>
                            Tentang Kami
                        </h1>
                        <p>
                            Kami adalah penyelenggara Layanan Pendanaan Bersama Berbasis Teknologi Informasi yang telah Berizin dari Otoritas Jasa Keuangan (OJK)  sesuai dengan surat keputusan nomor
                            <strong> KEP-76/D.05/2021</strong> tanggal 19 Agustus 2021 tentang Pemberian Izin Usaha Perusahaan Penyelenggara Layanan Pinjam Meminjam
                            Uang Berbasis Teknologi Informasi.
                        </p>
                        <br />
                        <p>
                            Kami mempertemukan Peminjam dan Pemberi Pinjaman melalui platform <strong>Danai.id.</strong>
                        </p>
                    </div>
                </div>
            </article>
        </>
    );
}

export default Header;
